import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../../utility/Utility"; // Adjust this import if needed
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

export default function AddHelpAndSupportCategory() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    category: ""
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await postData("api/support/categories/add", {
        category: formData.category
      });

      if (response?.success) {
        toast.success(response.message || "Category added successfully!");
        navigate(-1);
      } else {
        toast.error(response?.message || "Failed to add category");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error("Add category error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={5000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          {/* Header & Breadcrumbs */}
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            {/* ... */}
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              <i className="fas fa-arrow-left me-1"></i> Back
            </button>
          </div>

          {/* Form Card */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                {/* Card Header */}
                <div className="card-header">
                  <h5 className="card-title mb-0">Create New Help and Support Category</h5>
                </div>
                {/* Card Body */}
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    {/* Category */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label htmlFor="category" className="form-label fw-medium">
                          Category <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="category"
                          name="category"
                          className="form-control"
                          placeholder="Enter category"
                          value={formData.category}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="row mt-4">
                      <div className="col-md-6 offset-md-3">
                        <button
                          type="submit"
                          className="btn btn-primary py-2"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Processing...
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}